import Vue from 'vue';
import i18n from './../langs/i18n.js';
import qs from 'qs';

export default class ListUtils {
  static loadItemsData (instance, endpoint, listField, params = {}, method = 'post') {
    instance.$http[method](endpoint, params).then(response => {
      instance[listField] = response.data.data;
      instance.loaded = true;
    }).catch(error => {
      console.log(error);
      instance.loadError = true;
    });
  }

  static loadPaginatedItemsData (instance, config) {
    let methodToUse = 'post';

    if (config.method === 'get') {
      methodToUse = 'get';
    }

    if (config.method === 'get' && config.params) {
      config.params = {
        params: config.params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
      };
    }

    instance.loaded = false;
    instance.loadError = false;

    instance.$http[methodToUse](config.endpoint, config.params).then(response => {
      instance[config.listField] = response.data.data;
      instance.paginationMetaData = response.data.meta || null;
      instance.loaded = true;

      if (config.successAction) {
        config.successAction();
      }
    }).catch(error => {
      console.log(error);
      instance.loadError = true;
    });
  }

  static removeItem (config) {
    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: i18n.t('ui.yesRemove'),
      cancelButtonText: i18n.t('ui.cancel')
    }).then((result) => {
      if (result.value) {
        config.$http.post(config.endpointBase + config.id).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: config.successText,
              type: 'success',
              timer: 2000,
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: config.errorText,
              type: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: config.errorText,
            type: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }

  static getKeyLabel (keys, label) {
    return keys[label];
  }
}
